import React, { useCallback } from 'react';

// DEPENDENCIES
import { useFormikContext } from 'formik';
import moment from 'moment';
import HTMLReactParser from 'html-react-parser';

// GLOBAL VARIABLES
import { ENDPOINTS } from 'endpoints.js';

// GLOBAL FUNCTIONS
import { documentChunkFetch, getFileType, shouldOpenFile, viewFile } from 'functions.js';

// LOCAL COMPONENTS
import Button from 'core/tools/Button';
import Card from 'parts/card/Card';
import Form from 'core/form/Form';

// STYLES
import styles from './spotInstructions.module.scss';

//Render
const RenderSpotInstructionsForm = () => {
  const { values } = useFormikContext();
  const { aryChecklist, arySpotInstruction } = values || {};

  const handleDownload = useCallback((fileId, fileName) => {
    const fileNameArray = fileName.split('.');
    const extension = fileNameArray.length > 1 ? fileName.split('.')[fileNameArray.length - 1] : undefined;
    const mimeType = getFileType(fileName);
    documentChunkFetch({
      endpoint: `${ENDPOINTS.uploads.sales.view}/${fileId}`,
      mimeType,
      loadingMessage: shouldOpenFile(mimeType) ? 'Opening file' : 'Downloading file',
      errorMessage: 'Unable to download file.',
      onSuccess: r => viewFile({ ...r, fileName: fileNameArray[0] }, extension, false, true)
    });
  }, []);

  return (
    <Form.Body>
      {Array.isArray(aryChecklist)
        ? aryChecklist.filter((item => item.spot_instruction_id)).map((v, i) => {
          const spotInstruction = arySpotInstruction.find(s => s.spot_instruction_id === v.spot_instruction_id);
          return (
            <Form.Row key={`${v.checklist_id}-${i}`} className="w-100 my-0">
              <Form.Col cols={{ xs: 24 }} className={styles.label}>
                <Form.Label className="pt-0">{`Spot Instruction ${i + 1}`}</Form.Label>
              </Form.Col>
              <Form.Col>
                <div className="px-2">
                  <div className="mb-2 large">{HTMLReactParser(v.checklist_text)}</div>
                  <div className="text-gray-600 small">
                    {v.is_completed
                      ? `Completed: On ${moment(v.date_updated).format('MM/DD/YYYY')} ${moment(v.date_updated).format(
                          'h:mm A'
                        )} by ${v.updated_by_fullname}`
                      : `Incompleted`}
                  </div>
                </div>
                {spotInstruction?.arySpotInstructionAttachment?.length ? (
                  <div className="w-100 mt-3 ms-2">
                    {spotInstruction.arySpotInstructionAttachment.map((a, j) => (
                      <div key={j} className="w-100 mb-2">
                        <Button.Link
                          label={a.salesattachment_filename}
                          icon="document"
                          className={styles.attachment}
                          onClick={() => handleDownload(a.salesattachment_id, a.salesattachment_filename)}
                        />
                      </div>
                    ))}
                  </div>
                ) : null}
              </Form.Col>
            </Form.Row>
          )})
        : null}
    </Form.Body>
  );
};

export default function SpotInstructionsInfo(props) {
  const { values } = useFormikContext();
  return values?.aryChecklist?.length > 0 ? (
    <Card title="Spot Instructions" body={<RenderSpotInstructionsForm {...props} />} />
  ) : null;
}
